import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/react-circle-flags/react-circle-flags/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import { CircleFlag } from 'react-circle-flags';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "react-circle-flags"
    }}>{`react-circle-flags`}</h1>
    <h2 {...{
      "id": "install"
    }}>{`Install`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm install --save react-circle-flags
`}</code></pre>
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic usage`}</h2>
    <Playground __position={0} __code={'<CircleFlag countryCode=\"es\" />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      CircleFlag,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <CircleFlag countryCode="es" mdxType="CircleFlag" />
    </Playground>
    <p>{`You can pass all the react's `}<inlineCode parentName="p">{`React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>`}</inlineCode>{` props to CircleFlag.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      